(function(){
  const Fm = {
    cart: { items: [] },
    qty: 1,
    toast(msg){
      const t = document.getElementById('FmToast');
      if(!t) return;
      t.textContent = msg;
      t.classList.add('show');
      clearTimeout(this._tt);
      this._tt = setTimeout(()=>t.classList.remove('show'), 2600);
    },
    openDrawer(){ document.getElementById('CartDrawer').classList.add('open'); },
    closeDrawer(){ document.getElementById('CartDrawer').classList.remove('open'); },
    async refresh(){
      try{
        const res = await fetch('/cart.js');
        this.cart = await res.json();
      }catch(e){}
      this.renderDrawer();
    },
    renderDrawer(){
      const c = this.cart;
      document.getElementById('drawerCount').textContent = '(' + c.item_count + ')';
      document.querySelectorAll('.cart-count').forEach(el=> el.textContent = c.item_count);
      document.getElementById('drawerSubtotal').textContent = '$' + ((c.total_price||0)/100).toFixed(2);
      const box = document.getElementById('drawerItems');
      if(!c.items || !c.items.length){
        box.innerHTML = '<div class="drawer-empty">Your cart is currently empty.<br>Let\'s find gear for your pet.</div>';
        return;
      }
      box.innerHTML = c.items.map(i =>
        '<div class="drow"><img src="'+ (i.image ? i.image.replace(/(\.[^.]*)$/, '_160x$1') : '') +'" alt="'+ i.product_title +'">'+
        '<div><div style="font-weight:700;font-size:14.5px">'+ i.product_title +'</div>'+
        '<div style="color:var(--brand);font-weight:700;font-size:14px;margin-top:3px">$'+ (i.final_line_price/100).toFixed(2) +' <span style="color:var(--ink-soft);font-weight:400">× '+ i.quantity +'</span></div></div></div>'
      ).join('');
    },
    async add(variantId, qty){
      try{
        await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body: JSON.stringify({id: variantId, quantity: qty||1})
        });
        await this.refresh();
        this.openDrawer();
        this.toast('Added to cart');
      }catch(e){
        this.toast('Could not add to cart');
      }
    }
  };
  window.Fm = Fm;

  document.addEventListener('DOMContentLoaded', function(){
    Fm.refresh();

    // mobile menu
    const mm = document.getElementById('MobileMenu');
    const mt = document.querySelector('.menu-toggle');
    if(mt) mt.addEventListener('click', ()=> mm.classList.toggle('open'));

    // FAQ accordion
    document.querySelectorAll('.faq-q').forEach(q=>{
      q.addEventListener('click', ()=> q.parentElement.classList.toggle('open'));
    });

    // Quantity stepper
    document.querySelectorAll('.qty-stepper').forEach(stepper=>{
      const input = stepper.querySelector('.qty-input');
      stepper.querySelectorAll('.qty-btn').forEach(btn=>{
        btn.addEventListener('click', ()=>{
          const step = btn.dataset.qty === 'plus' ? 1 : -1;
          let val = parseInt(input.value) || 1;
          val = Math.max(1, val + step);
          input.value = val;
        });
      });
    });

    // Product gallery thumb switch
    document.querySelectorAll('.gallery-thumb').forEach(thumb=>{
      thumb.addEventListener('click', ()=>{
        document.querySelectorAll('.gallery-thumb').forEach(t=>t.classList.remove('active'));
        thumb.classList.add('active');
        const mainImg = document.getElementById('mainImage');
        if(mainImg && thumb.dataset.full){
          mainImg.src = thumb.dataset.full;
        }
      });
    });

    // Swatch selection changes main image
    document.querySelectorAll('.swatch-radio').forEach(radio=>{
      radio.addEventListener('change', ()=>{
        if(radio.checked && radio.dataset.mainImg){
          const mainImg = document.getElementById('mainImage');
          if(mainImg){
            mainImg.src = radio.dataset.mainImg;
            document.querySelectorAll('.gallery-thumb').forEach(t=>t.classList.remove('active'));
          }
        }
      });
    });

    // AJAX add buttons with data-variant
    document.querySelectorAll('[data-add-to-cart]').forEach(btn=>{
      btn.addEventListener('click', (e)=>{
        e.preventDefault();
        Fm.add(parseInt(btn.dataset.addToCart), 1);
      });
    });
  });
})();

